import React from "react";

function BrandedTransition({ message }) {
  return (
    <div className="flex flex-col items-center justify-center space-y-6 animate-in fade-in duration-500">
      <div className="relative w-48 h-48 flex items-center justify-center">
        <div className="absolute inset-0 motion-safe:animate-[spin_20s_linear_infinite] opacity-80">
          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full drop-shadow-[0_0_15px_rgba(124,58,237,0.2)]">
            <path
              fill="#4C1D95"
              d="M44.7,-76.4C58.1,-69.2,69.5,-57.4,77.5,-43.8C85.5,-30.2,90.2,-15.1,89.5,-0.4C88.8,14.3,82.8,28.6,74.2,41.2C65.5,53.8,54.2,64.7,41.1,72.4C28,80.1,14,84.7,-0.7,85.9C-15.4,87.1,-30.8,85,-44.6,78.2C-58.4,71.4,-70.6,59.9,-78.9,46.1C-87.2,32.3,-91.7,16.2,-91.3,0.2C-90.9,-15.7,-85.6,-31.4,-76.3,-44.8C-67,-58.1,-53.8,-69.1,-39.6,-75.7C-25.3,-82.3,-10.1,-84.5,3.7,-90.9C17.5,-97.3,31.3,-83.6,44.7,-76.4Z"
              transform="translate(100 100)"
            />
          </svg>
        </div>
        <div className="absolute inset-0 motion-safe:animate-[spin_15s_linear_infinite_reverse] opacity-60 mix-blend-screen">
          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
            <path
              fill="var(--gmb-primary)"
              d="M38.1,-65.4C49.1,-58.8,57.6,-48.4,65.8,-36.8C74.1,-25.1,82.1,-12.6,81.8,-0.1C81.6,12.3,73,24.7,64.3,35.6C55.6,46.5,46.8,55.9,36,63.7C25.2,71.6,12.6,77.9,-0.6,79C-13.8,80,-27.7,75.9,-39.1,68.4C-50.5,60.9,-59.4,50,-66.6,38.1C-73.8,26.2,-79.3,13.1,-80.6,-0.8C-81.9,-14.7,-79,-29.4,-71,-41.8C-63,-54.2,-50,-64.3,-37.1,-69.8C-24.1,-75.3,-12.1,-76.1,0.5,-77C13.1,-77.9,27.1,-72.1,38.1,-65.4Z"
              transform="translate(100 100)"
            />
          </svg>
        </div>
        <div className="absolute w-12 h-12 bg-white rounded-full blur-xl opacity-40 animate-pulse" />
        <svg viewBox="0 0 100 100" className="relative z-10 w-24 h-24 overflow-visible">
          <defs>
            <filter id="glow-cm">
              <feGaussianBlur stdDeviation="2" result="coloredBlur" />
              <feMerge>
                <feMergeNode in="coloredBlur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          <path
            className="motion-safe:animate-[g-form_4s_ease-in-out_infinite]"
            d="M70,30 C60,15 30,15 20,40 C10,65 30,85 55,85 C75,85 85,70 85,55 L55,55"
            fill="none"
            stroke="white"
            strokeWidth="8"
            strokeLinecap="round"
            strokeDasharray="200"
            strokeDashoffset="200"
            style={{ filter: "url(#glow-cm)", opacity: 0.8 }}
          />
        </svg>
      </div>
      {message && (
        <p className="text-gray-400 font-medium text-sm tracking-wide animate-pulse">{message}</p>
      )}
      <style>{`
        @keyframes g-form {
          0% { stroke-dashoffset: 200; opacity: 0; }
          40% { stroke-dashoffset: 0; opacity: 0.8; }
          60% { stroke-dashoffset: 0; opacity: 0.8; }
          100% { stroke-dashoffset: 0; opacity: 0; }
        }
      `}</style>
    </div>
  );
}

export default BrandedTransition;
